import React from 'react';
import PrintText from './PrintText';
import { Field } from 'redux-form/immutable';
import DateTimeClass from './FieldClasses/_DATE_TIME_CLASS';
import moment from 'moment';
import { ModelPropertiesParser } from '../commons/modelPropertiesParser';
import momentTime from 'moment-timezone';

const DateRange = (props) => {
    const { layoutItem, classProperty, type, validations,formValues, value, isReadOne, ...rest } = props;
    const _ranges = Array.isArray(value) && value.length ? value : ['', ''];
    const { itemProperties: { dateTimeConfig } } = layoutItem;
    
//  const  findingDateValue = props.formValues && classProperty && formValues[`${classProperty}`]   ? moment(formValues[`${classProperty}`]) : null
//     console.log("Dates a", findingDateValue, "workflow data", props.workflowData)
//     console.log("Date and time", props)
   

    let dateTimeDefaultValue = props.formValues && classProperty && formValues[`${classProperty}`]   ? moment(formValues[`${classProperty}`]) : null;
    if (dateTimeConfig) {
        const { workflow } = props;
        if(workflow && workflow.selectedStartDateTime && workflow.selectedEndDateTime) {
            if (dateTimeConfig.calendarLoadType && dateTimeConfig.calendarLoadType.name === 'START') {
                const newDateTime = moment(workflow.selectedStartDateTime, "x");
                dateTimeDefaultValue = newDateTime;
            } else if(dateTimeConfig.calendarLoadType && dateTimeConfig.calendarLoadType.name === 'END') {
                const newDateTime = moment(workflow.selectedEndDateTime, "x");
                dateTimeDefaultValue = newDateTime;
            }
        }
    }

    if(dateTimeDefaultValue) {
        let updatedTime = dateTimeDefaultValue.clone();
        const offSet = dateTimeDefaultValue.utcOffset();
        updatedTime = updatedTime.add(offSet, 'minutes');
        if(props.companyDetails && props.companyDetails.data && props.companyDetails.data.timezone && props.companyDetails.data.timezone != "GMT") {
            const tz = props.companyDetails.data.timezone;
            const atz = tz.split('/').map(p => p[0] + p.slice(1).toLowerCase()).join('/');
            let newValue = momentTime.tz(dateTimeDefaultValue, atz);
            newValue = newValue.format("YYYY-MM-DD hh:mm");
            const localTz = momentTime.tz.guess();  // e.g., "Asia/Kolkata"
            dateTimeDefaultValue = momentTime.tz(newValue, atz).tz(localTz);
        } else {
            dateTimeDefaultValue = updatedTime;
        }
    }
    return (
        <div>
            {
                isReadOne ?
                    <PrintText {...props} /> :
                    <Field
                        name={classProperty}
                        component={DateTimeClass}
                        validate={validations}
                        fieldType={type}
                        layoutItem={layoutItem}
                        {...rest}
                        onBlur={() => {
                            const cEventKeys = window.cEvents && Object.keys(window.cEvents);
                            Array.isArray(cEventKeys) &&   cEventKeys.map(k => {
                                k.startsWith(classProperty) &&
                                window.cEvents[k](props.formValues);
                            });
                        }}
                        ranges={_ranges}
                        defaultValue={dateTimeDefaultValue}
                    />
            }
        </div>
    );
}

export default DateRange;
